var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasRoleToCreateClubs
    ? _c(
        "div",
        { staticClass: "version" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  _vm.centerDialogVisible = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.versionApp))]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Versiones",
                visible: _vm.centerDialogVisible,
                width: "80%",
                center: ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.centerDialogVisible = $event
                }
              }
            },
            [
              _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.activeNames,
                    callback: function($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames"
                  }
                },
                _vm._l(_vm.versionList, function(item, index) {
                  return _c(
                    "el-collapse-item",
                    {
                      key: item.title,
                      attrs: {
                        label: item.title,
                        name: index,
                        title: item.title
                      }
                    },
                    [
                      _c(
                        "ol",
                        _vm._l(item.changeList, function(item, index) {
                          return _c("li", { key: index }, [
                            _vm._v(" " + _vm._s(item))
                          ])
                        })
                      )
                    ]
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.centerDialogVisible = false
                        }
                      }
                    },
                    [_vm._v("Cerrar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13e1eccb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e1eccb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/VersionApp/index.vue
// module id = null
// module chunks = 